import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'src/app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

declare global {
  interface Window {
    CoralogixRum: any;
  }
}

initCoralogix();
if (environment.production) enableProdMode();

function initCoralogix() {
  if (environment?.coralogix?.public_key && !environment.development) {
    window?.CoralogixRum?.init({
      public_key: environment.coralogix.public_key,
      application: environment.coralogix.application,
      version: '1.0',
      coralogixDomain: 'AP1',
      instrumentations: {
        errors: true,           // ✅ Keep error tracking
        web_vitals: false,      // ❌ Disable Web Vitals
        interactions: false,    // ❌ Disable user interactions
        long_tasks: false,      // ❌ Disable long tasks
        resources: false,       // ❌ Disable resource timing
        fetch: false,           // ❌ Disable fetch tracking
        xhr: false,             // ❌ Disable XHR tracking
        custom: true            // Custom logs (e.g. API failure events from interceptors)
      },
      ignoreErrors: [
        /:\s*4\d{2}\s/,
        /:\s*5\d{2}\s/,
        /Gateway Timeout/i,
        /Bad Gateway/i,
        /Service Unavailable/i,
        /Internal Server Error/i,
        /Unauthorized/i,
        /Forbidden/i,
        /Not Found/i,
        /Failed to fetch/i,
        /NetworkError/i,
        /Network request failed/i,
        /net::ERR_/i,
        /CORS/i,
        /AbortError/i,
        /TimeoutError/i,
        /Http failure response/i
      ]
    });
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
